import useResizeObserver from "@react-hook/resize-observer";
import _ from "lodash";
import { useMemo, useRef, useState } from "react";

export const useRerenderWhenBodyResize = () => {
  const [measuredWidth, setMeasuredWidth] = useState(0);

  const nResizes = useRef(0);

  // in order to resize the inc bar when the tabview is resized
  // we detect when document.body resizes and then set state to trigger a rerender
  const debouncedSetWidth = useMemo(() => {
    return _.debounce((width: number) => {
      nResizes.current++;

      // skip first measurement since its not needed
      if (nResizes.current > 1) {
        // set state to trigger rerender
        setMeasuredWidth(width);
      }
    }, 100);
  }, []);

  useResizeObserver(document.body, (entry) => {
    const target = entry.target as HTMLElement;
    debouncedSetWidth(target.offsetWidth);
  });
};
